export default __webpack_public_path__ + "static/char-s-59-ko-7687a0d084e1ced05fa030913fc3c33b.webp";